export function getOrderNote(order, name) {
  const note = order.notes.find((note) => note.name === name);
  return note ? note.value : null;
}

export function getOrderDocuments(order) {
  const documents = {};

  if (order.packing_slip_links && order.packing_slip_links.length) {
    documents.packing_slip_links = order.packing_slip_links;
  }

  const returnLabel = getOrderNote(order, 'Return Label');
  if (returnLabel) {
    documents.return_label = returnLabel;
  }

  const shippingLabel = getOrderNote(order, 'Shipping Label');
  if (shippingLabel) {
    documents.shipping_label = shippingLabel;
  }

  return documents;
}

export function getOrderDocumentsFilename(order) {
  return order.retailer_order_id.replace(/[^a-z0-9]/gi, '_').toLowerCase() + '.pdf';
}

export function getFullAddressInHtml(address) {
  if (!address || isEmptyAddress(address)) {
    return null;
  }

  const { address2, attention_line, state, city, zip_code } = address;
  const fullAddress = [address.address1];
  if (address2) {
    fullAddress.push(<br />, address2);
  }

  if (attention_line) {
    fullAddress.push(<br />, attention_line);
  }

  fullAddress.push(<br />);

  if (state) {
    fullAddress.push(city, ` ${state}, `);
  } else {
    fullAddress.push(`${city}, `);
  }

  fullAddress.push(address.country);

  if (zip_code) {
    fullAddress.push(<br />, zip_code);
  }

  return fullAddress.map((text, i) => <span key={i}>{text}</span>);
}

export function isEmptyAddress(address) {
  if (!address) {
    return true;
  }
  const { address1, address2, attention_line, state, city, zip_code, country } = address;
  return [address1, address2, attention_line, state, city, zip_code, country].every((item) => !item || item === '');
}

export function getShippingMethod(object) {
  return object.shipping_method ? object.shipping_method.description : object.shipping_method_code;
}
